import { iconsStatusMatcher } from '../../../../utils/generators/iconsStatusMatcher.jsx'
import {Icons} from '../../../../common/Icons.jsx'

export const createTableListaSprawozdan = () => {
    return [
        {
            accessorKey: 'id',
            header: 'ID',
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'numer',
            header: 'Numer',
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'status',
            filterFn: 'equals',
            header: 'Status',
            cell: ({ row }) => {
                const status = row.original.status
                const icon = iconsStatusMatcher[status]?.icon
                const color = iconsStatusMatcher[status]?.color
                const prosbaOdblokowanie = row.original.czy_prosba_odblokowanie === 'Tak'

                return (
                    <div
                        className={
                            'd-flex ms-2 gap-2 align-content-center align-items-center'
                        }
                    >
                        <span className={`p-1 text-${color}`}>
                            {icon}
                        </span>
                        <div className="d-flex flex-column">
                            <div>{status}</div>
                            {prosbaOdblokowanie && (
                                <small title={'Prośba o odblokowanie'} className="text-warning fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22} />
                                </small>
                            )}
                        </div>
                    </div>
                )
            },
            meta: {
                filterVariant: 'select',
                options: [
                    { id: 'W_EDYCJI', nazwa: 'W_EDYCJI' },
                    { id: 'ZŁOŻONY', nazwa: 'ZŁOŻONY' },
                    { id: 'PRZYJĘTY', nazwa: 'PRZYJĘTY' },
                    { id: 'DO_POPRAWY', nazwa: 'DO_POPRAWY' },
                    { id: 'ZAKOŃCZONY', nazwa: 'ZAKOŃCZONY' },
                ],
            },
        },
        {
            accessorKey: 'wersja',
            header: 'Wersja',
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'rok',
            header: 'Rok',
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'kwartal',
            header: 'Kwartał',
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: 'updated_at',
            header: 'Data aktualizacji',
            enableColumnFilter: false,
            cell: ({ row }) => {
                const date = row.original.updated_at
                if (!date) return '-'
                return date.split('T')[0]
            },
        },
    ]
}
